/* Google OAuth callback — exchanges session_id (from URL fragment) for a JWT
 * and stores it, then redirects to the dashboard.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, refresh } = useAuth();
  const done = useRef(false);
  const [state, setState] = useState("processing"); // processing | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setState("error");
      setMsg("No Google session token found in URL.");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/exchange", { session_id });
        // Persist token using the same key AuthContext reads
        try { localStorage.setItem("zj_access_token", data.access_token); } catch { /* ignore */ }
        if (typeof setUser === "function") setUser(data.user);
        try { await refresh(); } catch { /* ignore */ }
        toast.success(`Signed in as ${data.user?.email}`);
        // Clean the URL fragment and hard-redirect
        window.history.replaceState({}, document.title, "/dashboard");
        window.location.href = "/dashboard";
      } catch (e) {
        setState("error");
        setMsg(e.response?.data?.detail || "Google sign-in failed. Please try again.");
      }
    })();
  }, [nav, setUser, refresh]);

  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center",
      background: "linear-gradient(180deg, #FAFAF7 0%, #fff 100%)", padding: 24,
    }} data-testid="auth-callback">
      <div style={{ maxWidth: 460, width: "100%", background: "#fff", padding: 32,
                    borderRadius: 12, boxShadow: "0 20px 50px -18px rgba(15,23,42,0.15)",
                    textAlign: "center" }}>
        {state === "processing" ? (
          <>
            <div style={{
              width: 40, height: 40, margin: "0 auto 16px",
              border: "3px solid #E5E7EB", borderTopColor: "#DC2626",
              borderRadius: "50%", animation: "spin 0.9s linear infinite",
            }} />
            <div style={{ fontWeight: 700, fontSize: 16, color: "#0F172A" }}>Signing you in with Google…</div>
            <div style={{ fontSize: 13, color: "#64748B", marginTop: 6 }}>You'll be redirected to your workspace in a moment.</div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </>
        ) : (
          <>
            <div style={{ fontWeight: 800, fontSize: 18, color: "#B91C1C" }}>Google sign-in failed</div>
            <div style={{ fontSize: 14, color: "#64748B", marginTop: 8 }}>{msg}</div>
            <button onClick={() => nav("/")} style={{
              marginTop: 20, padding: "10px 20px", background: "#DC2626", color: "#fff",
              border: "none", borderRadius: 8, fontWeight: 600, cursor: "pointer",
            }} data-testid="auth-callback-back">Back to home</button>
          </>
        )}
      </div>
    </div>
  );
}
